import { Tooltip } from '@jutro/components';
import { BreakpointTrackerContext } from '@jutro/layout';
import { useTranslator } from '@jutro/locale';
import { MockUpUtil } from '@xengage/gw-portals-util-js';
import { commonQuoteStyles } from 'gw-capability-quoteandbind-common-react';
import _ from 'lodash';
import PropTypes from 'prop-types';
import React, { useContext } from 'react';
import messages from './LobQuoteInfo.messages';
import styles from './LobQuoteInfo.module.scss';

const PATH_TO_MOCK_DATA = 'quote.PremierCL';

function LobQuoteInfo(props) {
    const { submissionVM } = props;
    const translator = useTranslator();
    const breakpoint = useContext(BreakpointTrackerContext);
    const quoteId = _.get(submissionVM, 'quoteID.value');
    const address = _.get(submissionVM, 'baseData.policyAddress.value');
    const { displayName } = address;
    const isAddressDisplayNameMocked = MockUpUtil.isDisplayNameMocked(
        _.get(submissionVM, 'value'),
        PATH_TO_MOCK_DATA,
        'baseData.policyAddress.displayName',
        'baseData.policyAddress.addressLine1',
        'baseData.policyAddress.city'
    );
    const policyAddressToShowInHeader = isAddressDisplayNameMocked
        ? `${address.state} ${address.postalCode}`
        : displayName;
    if (breakpoint === 'phone' || breakpoint === 'phoneWide') {
        return (
            <div className={commonQuoteStyles.quoteInfoBar}>
                <div className={commonQuoteStyles.quoteWrapper}>
                    <div className={styles.infoBlock}>
                        <div className={commonQuoteStyles.infoBlockTitle}>
                            {translator(messages.quote)}
                        </div>
                        <div
                            id="contextSubmissionId"
                            className={commonQuoteStyles.infoBlockContent}
                        >
                            {quoteId}
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className={commonQuoteStyles.quoteInfoBar}>
            <div className={commonQuoteStyles.quoteWrapper}>
                <div className={styles.infoBlock}>
                    <div className={commonQuoteStyles.infoBlockTitle}>
                        {translator(messages.quote)}
                    </div>
                    <div
                        id="contextSubmissionId"
                        className={commonQuoteStyles.infoBlockContent}
                    >
                        {quoteId}
                    </div>
                </div>
                <div className={styles.infoBlock}>
                    <div className={commonQuoteStyles.infoBlockTitle}>
                        {translator(messages.location)}
                    </div>
                    <div
                        id="contextLocation"
                        className={commonQuoteStyles.infoBlockContent}
                    >
                        <Tooltip
                            id="policyLocation"
                            placement="bottom"
                            trigger="mouseenter"
                            content={policyAddressToShowInHeader}
                        >
                            <div className={commonQuoteStyles.infoOverflow}>
                                {policyAddressToShowInHeader}
                            </div>
                        </Tooltip>
                    </div>
                </div>
            </div>
        </div>
    );
}

LobQuoteInfo.propTypes = {
    submissionVM: PropTypes.shape({}).isRequired,
};

export default LobQuoteInfo;
